import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LoadingBoxWithoutText from "../../modules/shared/components/LoadingBoxWithoutText";
import { removeDuplicatesFromArray } from "../../libraries/ercLibrary";

export default function SelectMultiVariant(props) {
  const locationPath = useLocation().pathname;

  // PROPS COMING FROM ProductScreenNew & FreeProductAddToCart & ProductLandings
  const {
    singleSku,
    fullVariantsArray,
    setChoosenVariants,
    setVariantAlert,
    setNoSkuAlert,
    variantAlert,
    areVariantsInArow,
    loadingSku,
  } = props;

  // DETECT PRICE VARIATIONS IF ANY
  const [isTherePriceVariations, setIsTherePriceVariations] = useState(false);
  const [labels, setLabels] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  useEffect(() => {
    if (
      fullVariantsArray?.length > 0 &&
      !fullVariantsArray.includes(undefined)
    ) {
      const priceVariationsArray = removeDuplicatesFromArray(
        fullVariantsArray.flatMap((variant) =>
          variant.skus.map((sku) => sku.price)
        )
      );
      const variantLabels = removeDuplicatesFromArray(
        fullVariantsArray.flatMap((variant) =>
          variant.label.replace(" Seçiniz", "").toLowerCase()
        )
      );

      if (priceVariationsArray?.length > 1) {
        setIsTherePriceVariations(true);
        setLabels(variantLabels);
      }
    }

    return () => setLabels([]);
  }, [fullVariantsArray]);

  // SELECT IN ORDER ALERT
  const [selectAlert, setSelectAlert] = useState("");

  return (
    <>
      {singleSku
        ? ""
        : fullVariantsArray &&
          fullVariantsArray.length > 0 &&
          fullVariantsArray.map((variantGroups, index) => (
            <div
              key={variantGroups.label}
              className="row-center-webkit w90p marb-q"
            >
              <div className="w100p">
                <div className="row whitebck h2r beddo-border-bottom">
                  <select
                    style={{
                      border: "none",
                      fontSize: "16px",
                      width: "100%",
                      color: "grey",
                    }}
                    onClick={(e) => {
                      setIsClicked(true);
                      setNoSkuAlert("");
                      setVariantAlert({ index: -1, message: "" });
                      variantGroups.availableVariants.length === 1 &&
                      e.target.value.includes("Seçiniz")
                        ? setSelectAlert(index)
                        : setSelectAlert("");
                    }}
                    onChange={(e) => {
                      const currentItem = e.target.value;

                      fullVariantsArray.length === 1
                        ? setChoosenVariants([e.target.value])
                        : setChoosenVariants((prev) =>
                            [e.target.value, ...prev]
                              .map((item) =>
                                item !== currentItem &&
                                item.slice(0, 1) === currentItem.slice(0, 1)
                                  ? null
                                  : item
                              )
                              .filter((item) => item !== null)
                              .sort()
                          );
                    }}
                  >
                    {variantGroups &&
                      variantGroups.availableVariants.map(
                        (variant, optionsIndex) => (
                          <option
                            key={variant}
                            /*This index is prefixed into the variant to understand from which block of select the variant is choosen from
                      If it is from the same block than previose variant is removed from the array in select onChange function. */
                            value={index + "-" + variant}
                            className="iphone-fs"
                          >
                            {/*Remove variant infos such as label and code*/}
                            {optionsIndex !== 0
                              ? variant.split("-")[1]
                              : variant}
                          </option>
                        )
                      )}
                  </select>
                </div>
                {isTherePriceVariations &&
                  isClicked &&
                  index === 0 &&
                  (labels.length === 1 ? (
                    <p className="fs1 green txtcenter rad2-5r margintop-25 padq greenbcklight">
                      Özellik seçimine göre farklı fiyatlar var
                    </p>
                  ) : (
                    labels.length > 1 &&
                    !locationPath.includes("toptan") && (
                      <p className="fs1 green txtcenter rad2-5r margintop-25 padq greenbcklight">{`Bedenlerin fiyat ve resimleri farklı. İncelemek için renk de seçiniz.`}</p>
                    )
                  ))}
                {selectAlert === index && (
                  <p className="fs1 red-col txtcenter rad2-5r margintop1-5 padq lighterredbck">
                    {areVariantsInArow
                      ? "Soldan sağa sıralı seçim yapmalısınız!"
                      : "Yukarıdan aşağıya sıralı seçim yapmalısınız!"}
                  </p>
                )}
                {variantAlert && variantAlert.index === index && (
                  <p className="fs1 red-col txtcenter rad2-5r margintop-25 padq lighterredbck">
                    {variantAlert.message}
                  </p>
                )}
              </div>
            </div>
          ))}
      {loadingSku && <LoadingBoxWithoutText />}
    </>
  );
}
